import "./activity";
import "./admin";
import "./building";
import "./campaign";
import "./campaign-plan";
import "./cancel";
import "./canvass";
import "./canvass-status";
import "./canvasser-tracking";
import "./checklist";
import "./collection-purpose";
import "./page-heading";
import "./chart";
import "./consent-type";
import "./custom-fields";
import "./customize";
import "./conversion-rate-config";
import "./dashboard";
import "./data-record";
import "./data-set";
import "./division";
import "./document";
import "./duplicates";
import "./dummy-data";
import "./effort";
import "./essentials";
import "./event";
import "./export";
import "./feature";
import "./field";
import "./filter";
import "./general";
import "./group";
import "./help-text";
import "./home";
import "./house";
import "./house-occupant";
import "./integration";
import "./invite";
import "./issue";
import "./leader-board";
import "./limit";
import "./login";
import "./logs";
import "./map";
import "./nation-builder";
import "./navigation";
import "./notification";
import "./organisation";
import "./organisation-invite";
import "./organisation-settings";
import "./organisation-user";
import "./organisation-user-map";
import "./people";
import "./permission-level";
import "./privacy";
import "./product";
import "./profile";
import "./profile-menu";
import "./prospector";
import "./public-api";
import "./qr-code";
import "./request-access";
import "./reset-password";
import "./result";
import "./signature";
import "./signup";
import "./street";
import "./subscription";
import "./survey";
import "./table";
import "./talking-point";
import "./team";
import "./user";
import "./user-map";
import "./voter-file";
import "./planner";
